import { createVanIconComponent } from "./van"

const ShareOutlined = createVanIconComponent("share-o")
export default ShareOutlined
